import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getProductAndPurchaseDocumentWithUniqueId } from '../../../Backend/firebase/product-and-purchase';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function ViewProductAndPurchase({ productAndPurchaseId }) {
    const classes = useStyles();
    const [records, setRecords] = useState([]);

    useEffect(async () => {
        try {
            const getProductAndPurchase = await getProductAndPurchaseDocumentWithUniqueId(productAndPurchaseId);
            setRecords(getProductAndPurchase[0]);
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update Product And Purchase." />
                    <title>View Product And Purchase | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <div className="card-events-popup">
                        <div className="card-events-body d-flex flex-column">
                            <div className="card-events-details-popup">
                                <h5 className="card-events-title product__mainTitle">{records.ProductName}</h5>
                                {records.PrimaryPack && <p className="card-events-title">Primary Pack: <b>{records.PrimaryPack}</b></p>}
                                {records.SecondaryPack && <p className="card-events-title">Secondary Pack: <b>{records.SecondaryPack}</b></p>}
                                {records.PackConversion && <p className="card-events-title">Pack Conversion: <b>{records.PackConversion}</b></p>}
                                {records.StockAsPerPrimaryPack && <p className="card-events-title">Stock (As per Primary Pack): <b>{records.StockAsPerPrimaryPack}</b></p>}
                                {records.MRPAsPerPrimaryPack && <p className="card-events-title">MRP (as per Primary Pack): <b>{`Rs.${records.MRPAsPerPrimaryPack}`}</b></p>}
                                {records.SellingPriceAsPerPrimaryPack && <p className="card-events-title">Selling Price (as per primary pack): <b>{`Rs.${records.SellingPriceAsPerPrimaryPack}`}</b></p>}
                                {records.PurchaseDate && <p className="card-events-title">Purchase Date: <b>{records.PurchaseDate}</b></p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewProductAndPurchase
